/* eslint-disable */
import React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

/**
 * Lightweight client-side pager for inventory tables.
 * Props: page (1-based), pageSize, total, onPageChange(nextPage)
 */
function TablePagination({ page, pageSize, total, onPageChange }) {
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  if (total === 0) return null;

  const start = (page - 1) * pageSize + 1;
  const end = Math.min(page * pageSize, total);

  // Build a compact window of page numbers around the current page.
  const pages = [];
  const from = Math.max(1, page - 1);
  const to = Math.min(totalPages, page + 1);
  for (let p = from; p <= to; p++) pages.push(p);

  const btn =
    "min-w-[34px] h-[34px] flex items-center justify-center rounded-lg text-sm font-semibold border transition-colors";

  return (
    <div className="flex flex-wrap items-center justify-between gap-3 px-6 py-3 border-t border-gray-100 dark:border-gray-700">
      <p className="text-xs text-gray-500 dark:text-gray-400">
        Showing <span className="font-semibold">{start}</span>–
        <span className="font-semibold">{end}</span> of{" "}
        <span className="font-semibold">{total}</span>
      </p>

      <div className="flex items-center gap-1">
        <button
          onClick={() => onPageChange(page - 1)}
          disabled={page <= 1}
          className={`${btn} border-gray-200 text-gray-600 hover:bg-gray-100 disabled:opacity-40 disabled:cursor-not-allowed dark:border-gray-600 dark:text-gray-300 dark:hover:bg-gray-700`}
        >
          <ChevronLeft size={16} />
        </button>

        {from > 1 && (
          <>
            <button onClick={() => onPageChange(1)} className={`${btn} border-gray-200 text-gray-600 hover:bg-gray-100 dark:border-gray-600 dark:text-gray-300`}>1</button>
            {from > 2 && <span className="px-1 text-gray-400">…</span>}
          </>
        )}

        {pages.map((p) => (
          <button
            key={p}
            onClick={() => onPageChange(p)}
            className={`${btn} ${
              p === page
                ? "bg-emerald-600 text-white border-emerald-600 shadow"
                : "border-gray-200 text-gray-600 hover:bg-gray-100 dark:border-gray-600 dark:text-gray-300 dark:hover:bg-gray-700"
            }`}
          >
            {p}
          </button>
        ))}

        {to < totalPages && (
          <>
            {to < totalPages - 1 && <span className="px-1 text-gray-400">…</span>}
            <button onClick={() => onPageChange(totalPages)} className={`${btn} border-gray-200 text-gray-600 hover:bg-gray-100 dark:border-gray-600 dark:text-gray-300`}>{totalPages}</button>
          </>
        )}

        <button
          onClick={() => onPageChange(page + 1)}
          disabled={page >= totalPages}
          className={`${btn} border-gray-200 text-gray-600 hover:bg-gray-100 disabled:opacity-40 disabled:cursor-not-allowed dark:border-gray-600 dark:text-gray-300 dark:hover:bg-gray-700`}
        >
          <ChevronRight size={16} />
        </button>
      </div>
    </div>
  );
}

export default TablePagination;
